export const types = {
    SET_PREVIOUS_LOCATION: 'SET_PREVIOUS_LOCATION',
  }
  
  export const initialState = {
    previousLocation: '',
    history: [''],
  }
  
  const MyRouterReducer = (state = initialState, action) => {
    switch (action.type) {
      case types.SET_PREVIOUS_LOCATION: {
        state.history.push(action.location);
        let previousLocation = '';
        try {
          previousLocation = state.history[state.history.length - 2];
        } catch (err) {
          // console.log(JSON.stringify(state.history));
        }
  
        return {
          ...state,
          history: [...state.history],
          previousLocation,
        }
      }
      default: return { ...state }
    }
  }
  
  export const actions = {
    setPreviousLocation: location => ({ type: types.SET_PREVIOUS_LOCATION, location }),
  }
  
  export default MyRouterReducer;
  